import { useState, useEffect } from "react";
import api from "api/api";
import { useNavigate, Link, useLocation } from "react-router-dom";

//Material UI Components
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";

// import mui icons
import LineAxisOutlinedIcon from "@mui/icons-material/LineAxisOutlined";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

//Props Validations
import PropTypes from "prop-types";

//import component
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import Header from "../components/common/Header";
import PerformanceTab from "../components/overallKpi/overallKpiAnalysis/PerformanceTab";
import SecondaryAttributeTab from "components/overallKpi/secondaryAttributeAnalysis/SecondaryAttributeTab";
import Loader from "../components/common/Loader";
import MainNavigation from "../components/common/MainNavigation";

import { useDispatch, useSelector } from "react-redux";
import { loadOverallRemovedKpiListState, loadSecondaryRemovedKpiListState } from "store/features/analysisKpiSlice";
import { showNotification } from "store/features/notificationSlice";

function CustomTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
function OverallKpi({ headerTitle = "" }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;
    const navigationAvailability = useSelector((state) => state.studyDataStore.navigationAvailability);
    const textThemeSelections = useSelector((state) => state.textThemeStore.selections);
    const preserveModuleOnReturn = useSelector((state) => state.activeTabStore.preserveModuleOnReturn);
    const [selectedTab, setSelectedTab] = useState(() => {
        if (preserveModuleOnReturn === "secondary") return 1;
        if (preserveModuleOnReturn === "overall") return 0;
        return navigationAvailability["overall"] ? 0 : 1;
    });
    const [secondaryDataMappingData, setSecondaryDataMappingData] = useState([]);
    const [overallDataMappingData, setOverallDataMappingData] = useState([]);
    const [isSecondaryAttributeDataMappingDataLoading, setIsSecondaryAttributeDataMappingDataLoading] = useState(false);
    const [isOverallDataMappingDataLoading, setIsOverallDataMappingDataLoading] = useState(false);

    let sourceModuleName = null;
    if (location.pathname.includes("/overall-kpi")) {
        sourceModuleName = "Overall Analysis";
    } else if (location.pathname.includes("/secondary-attribute")) {
        sourceModuleName = "Secondary Analysis";
    }


    // const [textThemeSelections, setTextThemeSelections] = useState({});
    // const handleTextThemeSelectionChange = (selections) => {
    //     setTextThemeSelections(selections);
    // };

    const [btnDisabled, setBtnDisabled] = useState({
        overallKpi: true,
        agreementKpi: true,
        claims: true,
        correlation: true,
        textAnalysis: true,
        fragranceDriver: true,
    });

    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    const baseBtnArr = isOralCare || isSkinCleansing || isHairCare || isSkinCare 
        ? ["agreementKpi", "justRight", "claims", ...(isHairCare ? ["fragranceDriver"] : []), "correlation"] 
        : isUnileverFragranceHouse ? ["agreementKpi", "justRight", "correlation"] : ["agreementKpi", "claims", "correlation"];

    const isHomeUseTest = selectedStudy[0]?.study_type__title === "Home Use Test";
    const hasOpenEnded = navigationAvailability?.has_open_ended_variables;
    const showTextAnalysisButton = isDeodorants && isHomeUseTest && hasOpenEnded;

    const btnArr = showTextAnalysisButton
        ? [...baseBtnArr, "textAnalysis"]
        : baseBtnArr;


    const page = {
        0: "overall-kpi",
        1: "secondary-attribute",
        2: "driver-analysis",
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    // Clear the removed KPI data from the Redux store on page change to reset the default view.
    // Remove the code below if you want to retain the removed variables.
    useEffect(() => {
        return () => {
            dispatch(loadOverallRemovedKpiListState([]));
            dispatch(loadSecondaryRemovedKpiListState([]));
        };
    }, []);

    // Callback function to receive data from the child component
    // const onTTestDataReceived = (tTest, tTestConfidenceInterval, testType, testProducts, tTestCorDeataId, tTestAnalysisType, checkedDataTypeForTest) => {
    //     setTTestPerformed(tTest);
    //     setConfidenceInterval(tTestConfidenceInterval);
    //     setTTestType(testType);
    //     setTTestProducts(testProducts);
    //     setTTestCoreDataId(tTestCorDeataId);
    //     setTTestAnalysisType(tTestAnalysisType);
    //     setCheckedDataTypeForTest(checkedDataTypeForTest);
    // };

    const handleChange = (event, newValue) => {
        console.log("event", event, newValue);
        setSelectedTab(newValue);
    };

    const compareArrays = (arr1, arr2) => {
        const arrSorted2 = arr2.slice().sort();
        const isArrEqual =
            arr1.length === arr2.length &&
            arr1
                .slice()
                .sort()
                .every((value, index) => {
                    return value === arrSorted2[index];
                });
        return isArrEqual;
    };

    useEffect(() => {
        let _selectedStudies = selectedStudy;
        let disabled = true;
        let _country = _selectedStudies[0]?.country__title;
        let _deodorantFormat = _selectedStudies[0]?.format_data;

        if (isOralCare) {
            disabled = false;
        } else {
            _selectedStudies.forEach((each) => {
                if (each.country__title === _country && compareArrays(each.format_data, _deodorantFormat)) {
                    disabled = false;
                } else {
                    disabled = true;
                }
            });
        }

        let disableBtn = !_selectedStudies.length > 0;
        let tempObj = {
            overallKpi: disableBtn,
            agreementKpi: disableBtn,
            claims: disableBtn,
            correlation: disabled,
        };
        setBtnDisabled(tempObj);
    }, [selectedStudy, isOralCare]);

    useEffect(() => {
        async function fetchSecondaryAttributeDataMappingData() {
            try {
                const variableCategorySecondary = isHairCare ? "Secondary Attribute,Concept Secondary Attribute" : "Secondary Attribute";
                let url = process.env.REACT_APP_SERVER_PATH + `/data-mappings/all/?archive=false&uniq=true&variable_category=${encodeURIComponent(variableCategorySecondary)}`;
                if (productCategoryId) {
                    url += `&product_category=${productCategoryId}`;
                }
                setIsSecondaryAttributeDataMappingDataLoading(true);
                await api
                    .get(url)
                    .then((res) => {
                        setSecondaryDataMappingData(res.data);
                        setIsSecondaryAttributeDataMappingDataLoading(false);
                    })
                    .catch((error) => {
                        handleError("error", error);
                        setIsSecondaryAttributeDataMappingDataLoading(false);
                    });
            } catch (error) {
                handleError("error", error);
                setIsSecondaryAttributeDataMappingDataLoading(false);
            }
        }

        async function fetchOverallDataMappingData() {
            try {
                const variableCategoryOverall = isHairCare ? "KPI (OO),Concept KPI (OO)" : "KPI (OO),KPI ITM";
                let url = process.env.REACT_APP_SERVER_PATH + `/data-mappings/all/?archive=false&uniq=true&variable_category=${encodeURIComponent(variableCategoryOverall)}`;
                if (productCategoryId) {
                    url += `&product_category=${productCategoryId}`;
                }
                setIsOverallDataMappingDataLoading(true);
                await api
                    .get(url)
                    .then((res) => {
                        setOverallDataMappingData(res.data);
                        setIsOverallDataMappingDataLoading(false);
                    })
                    .catch((error) => {
                        handleError("error", error);
                        setIsOverallDataMappingDataLoading(false);
                    });
            } catch (error) {
                handleError("error", error);
                setIsOverallDataMappingDataLoading(false);
            }
        }

        if (selectedStudy.length === 0) {
            navigate("/studies");
        } else {
            fetchSecondaryAttributeDataMappingData();
            fetchOverallDataMappingData();
        }
    }, [selectedStudy, dispatch, navigate, productCategoryId]);

    useEffect(() => {
        if (selectedStudy.length === 0) {
            navigate("/studies");
        } else {
            navigate(`/overall-analysis/${page[selectedTab]}`, { replace: true });
        }
    }, [selectedTab, navigate, selectedStudy]);

    const getTab = (dataAvailable, label, seq) => {
        if (dataAvailable) {
            return (
                <Tab
                    className="tab-labels"
                    iconPosition="start"
                    icon={<LineAxisOutlinedIcon />}
                    label={label}
                    {...a11yProps(seq)}
                />
            );
        } else {
            return (
                <Tooltip title="No data present">
                    {/* Wrap in span to avoid tooltip suppression on disabled */}
                    <span>
                        <Tab
                            className="tab-labels"
                            iconPosition="start"
                            icon={<LineAxisOutlinedIcon />}
                            label={label}
                            disabled={true}
                            {...a11yProps(seq)}
                        />
                    </span>
                </Tooltip>
            );
        }
    };

    const hasActiveTextThemeSelection = textThemeSelections.some(item => item.isSelected === true);
    const finalBtnDisabledObj = { ...btnDisabled };

    if (hasActiveTextThemeSelection) {
        btnArr.forEach(btn => {
            finalBtnDisabledObj[btn] = true;
        });
        finalBtnDisabledObj.textAnalysis = false;
    } else {
        if (showTextAnalysisButton) {
            finalBtnDisabledObj.textAnalysis = true;
        }
    }

    return (
        <>
            {(isSecondaryAttributeDataMappingDataLoading || isOverallDataMappingDataLoading) && <Loader />}
            <Header
                title={headerTitle}
                isStudySelected={true}
                // tTestPerformed={tTestPerformed}
                // confidenceInterval={confidenceInterval}
                // tTestType={tTestType}
                // tTestProducts={tTestProducts}
                // tTestCoreDataId={tTestCoreDataId}
                // checkedDataTypeForTest={checkedDataTypeForTest}
                // tTestAnalysisType={tTestAnalysisType}
            />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel multipleLabel={true} />
            </div>

            <div
                style={{
                    minHeight: "calc(100vh - 170px)",
                }}
                className="full-container m-4 background-color-white  box-shadow--full-container"
            >
                <div
                    className=""
                    style={{
                        width: 150,
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                        zIndex: 10,
                    }}
                >
                    <Link
                        to="/studies"
                        onClick={(e) => {
                            if (window.history.length > 2) {
                                e.preventDefault();
                                navigate(-1);
                            }
                        }}
                    >
                        <div
                            className="p-2 liner-light-blue-background color-white"
                            style={{
                                borderRadius: "50%",
                                position: "relative",
                                top: -15,
                                left: -15,
                                cursor: "pointer",
                            }}
                        >
                            <span>
                                <ArrowBackIcon className="color-white" />
                            </span>
                        </div>
                    </Link>
                </div>

                <Tabs
                    sx={{
                        "& .MuiTabs-indicator": {
                            display: "none", // Hide the indicator
                        },
                    }}
                    // defaultActiveKey="uploadData"
                    value={selectedTab}
                    onChange={handleChange}
                    centered
                    aria-label="basic tabs example"
                    // onSelect={handleTabChange}
                    className="tabs-container tabs-toggle"
                >
                    {getTab(navigationAvailability["overall"], "Overall KPI analysis", 0)}
                    {getTab(navigationAvailability["secondary"], "Secondary Attribute Analysis", 1)}
                </Tabs>
                <CustomTabPanel
                    className="overall-kip-tab"
                    value={selectedTab}
                    index={0}
                >
                    {Object.keys(overallDataMappingData).length !== 0 && (
                        <PerformanceTab
                            selectedStudy={selectedStudy}
                            // onTTestDataReceived={onTTestDataReceived}
                            dataMappingData={overallDataMappingData}
                        />
                    )}
                </CustomTabPanel>
                <CustomTabPanel
                    className="overall-kip-tab"
                    value={selectedTab}
                    index={1}
                >
                    {secondaryDataMappingData.length !== 0 && (
                        <SecondaryAttributeTab
                            selectedStudy={selectedStudy}
                            dataMappingData={secondaryDataMappingData}
                        />
                    )}
                </CustomTabPanel>
                <div
                    style={{
                        position: "relative",
                        top: "5px",
                        marginTop: "30px",
                    }}
                >
                    <MainNavigation
                        buttons={btnArr}
                        btnDisabledObj={finalBtnDisabledObj}
                        textThemeNavState={{ from: sourceModuleName }}
                    />
                </div>
            </div>
        </>
    );
}

// Typechecking props for the OverallKpi
OverallKpi.propTypes = {
    headerTitle: PropTypes.string,
};

export default OverallKpi;
